import styled from '@emotion/styled';

export const ButtonGroup = styled('div')<{
  direction?: 'column' | 'row' | 'column-reverse' | 'row-reverse';
}>`
  display: flex;
  flex-direction: ${p => p.direction ?? 'row'};
`;

export default ButtonGroup;
